var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { List, styled, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import theme from '../../theme';
import { ButtonComponent } from '../shared/ButtonComponent/ButtonComponent';
import { useDispatch } from 'react-redux';
import { setCycloneProne, setEnclosureClassification, setExternalFire, setHail, setHasParapet, setInternalFire, setIsRiseRun, setRoofAreaHeight, setRoofAreaLength, setRoofAreaSlope, setRoofAreaWidth, setSurfaceRoughness, setWindSpeed, toggleCalc } from '../../reducers/calculatorReducer';
import { ApplicationContext } from '../ApplicationProvider';
import { getRoofAreaInfoById } from '../../services/RoofAreaService';
import { ENCLOSURE_CLASSIFICATION, EXTERNAL_FIRE, HAIL, INTERNAL_FIRE, SURFACE_ROUGHNESS } from '../constants/CALCULATOR_VALUES';
import { mapWindBorneData } from '../SavedItems/RoofAreaProperties';
import { Length } from '../../utils/Measurement/Length';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var topText1 = 'The Ratings Calculator allows you to specify fire and hail ratings, and calculate the wind uplift rating, for a roof area or for use in an assembly search.';
var topText2 = '. This way you only have to complete the fields in the Ratings Calculator once for a given roof area.';
var bottomText = 'You can complete as few or many of the fields in the Fire and Hail sections as desired. However, to calculate the wind uplift ratings, all fields in the Wind section must be completed. When you are finished you can perform an assembly search with the specified ratings and slope.'; // TODO: some issues re: styles not applying to LitItem. Revisit later
var StyledList = styled(List)({ '&.MuiList-root:': { fontWeight: '400', fontSize: '18px', display: 'list-item', listStylePosition: 'inside', listStyle: 'disc !important' }, '&.MuiList-root .MuiListItem-root:': { listStyleType: 'disc', display: 'list-item', listStylePosition: 'inside', fontWeight: '400', fontSize: '18px', fontFamily: 'Inter' } });
export var CalcLaunchComponent = function () {
    var dispatch = useDispatch();
    var _a = useState(false), loadData = _a[0], setLoadData = _a[1];
    var _b = useContext(ApplicationContext), hasCalcRatings = _b.hasCalcRatings, calcRatingRoofId = _b.calcRatingRoofId;
    var handleClick = function () { dispatch(toggleCalc(true)); };
    useEffect(function () { if (hasCalcRatings && calcRatingRoofId > 0) {
        var passCalcData = function () { return __awaiter(void 0, void 0, void 0, function () { var result, roofArea; return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadData(true);
                    return [4 /*yield*/, getRoofAreaInfoById(calcRatingRoofId)];
                case 1:
                    result = _a.sent();
                    roofArea = result[0];
                    mapExisitingData(roofArea);
                    dispatch(setIsRiseRun(true));
                    setLoadData(false);
                    return [2 /*return*/];
            }
        }); }); };
        passCalcData();
    }
    else {
        resetData();
    } setLoadData(false); });
    var mapExisitingData = function (roofArea) {
        // FIRE
        if (roofArea.IntFireRatingId) {
            dispatch(setInternalFire(INTERNAL_FIRE[roofArea.IntFireRatingId - 1]));
        }
        else {
            dispatch(setInternalFire({ value: undefined, name: 'None Selected' }));
        }
        if (roofArea.ExtFireRatingId) {
            dispatch(setExternalFire(EXTERNAL_FIRE[roofArea.ExtFireRatingId - 1]));
        }
        else {
            dispatch(setExternalFire({ value: undefined, name: 'None Selected' }));
        } // HAIL
        if (roofArea.HailRatingId) {
            dispatch(setHail(HAIL[roofArea.HailRatingId - 1]));
        }
        else {
            dispatch(setHail({ value: '', name: 'None Selected' }));
        } // WIND
        if (roofArea.GroundRoughnessRatingId) {
            dispatch(setSurfaceRoughness(SURFACE_ROUGHNESS[roofArea.GroundRoughnessRatingId - 1]));
        }
        else {
            dispatch(setSurfaceRoughness({ value: -1, name: '' }));
        }
        if (roofArea.WindBorneDebrisId) {
            dispatch(setEnclosureClassification(ENCLOSURE_CLASSIFICATION[mapWindBorneData(roofArea.WindBorneDebrisId)]));
        }
        else {
            dispatch(setEnclosureClassification({ value: -1, name: 'None Selected' }));
        }
        if (roofArea.ContinuousParapet) {
            dispatch(setHasParapet(roofArea.ContinuousParapet));
        }
        else {
            dispatch(setHasParapet(false));
        }
        if (roofArea.TropicalCycloneRegion) {
            dispatch(setCycloneProne(roofArea.TropicalCycloneRegion));
        }
        else {
            dispatch(setCycloneProne(false));
        } // SLOPE AND MEASURES
        if (roofArea.Height) {
            dispatch(setRoofAreaHeight(String(parseFloat((roofArea.Height / 12 / Length.INCH_TO_MM).toFixed(4)))));
        }
        else {
            dispatch(setRoofAreaHeight(''));
        }
        if (roofArea.Length) {
            dispatch(setRoofAreaLength(String(parseFloat((roofArea.Length / 12 / Length.INCH_TO_MM).toFixed(4)))));
        }
        else {
            dispatch(setRoofAreaLength(''));
        }
        if (roofArea.Width) {
            dispatch(setRoofAreaWidth(String(parseFloat((roofArea.Width / 12 / Length.INCH_TO_MM).toFixed(4)))));
        }
        else {
            dispatch(setRoofAreaWidth(''));
        }
        if (roofArea.WindSpeed) {
            dispatch(setWindSpeed(String(roofArea.WindSpeed)));
        }
        else {
            dispatch(setWindSpeed(''));
        }
        if (roofArea.Slope) {
            dispatch(setRoofAreaSlope(roofArea.Slope));
        }
        else {
            dispatch(setRoofAreaSlope(''));
        }
    };
    var resetData = function () { dispatch(setInternalFire({ value: undefined, name: 'None Selected' })); dispatch(setExternalFire({ value: undefined, name: 'None Selected' })); dispatch(setHail({ value: '', name: 'None Selected' })); dispatch(setSurfaceRoughness({ value: -1, name: '' })); dispatch(setEnclosureClassification({ value: -1, name: 'None Selected' })); dispatch(setHasParapet(false)); dispatch(setCycloneProne(false)); dispatch(setRoofAreaHeight('')); dispatch(setRoofAreaLength('')); dispatch(setRoofAreaWidth('')); dispatch(setWindSpeed('')); dispatch(setRoofAreaSlope('')); };
    return /*#__PURE__*/ _jsxs("div", { className: 'p-4 col-10', children: [/*#__PURE__*/ _jsx(Typography, { className: 'headline-1 py-4 d-inline-block', color: theme.palette.rnSteel.steel700, children: "Ratings Calculator" }), /*#__PURE__*/ _jsx("div", { className: 'row p-0 m-0', children: /*#__PURE__*/ _jsx(Typography, { className: 'large-para pb-3', children: topText1 }) }), /*#__PURE__*/ _jsx(Typography, { className: 'large-para pb-3', children: bottomText }), /*#__PURE__*/ _jsx("div", { className: 'py-2', children: /*#__PURE__*/ _jsx(ButtonComponent, { isDisabled: hasCalcRatings && loadData, id: "nextSection", buttonType: 'primary', click: handleClick, buttonText: 'Next', buttonStyle: 'mx-2 py-2' }) })] });
};
